export function createSVGIcon(text = "专家经验") {
  let content = ""
  const strs = text?.split("") || []
  const isSmall = strs?.length <= 2
  const padding = isSmall ? 24 : 20
  for (let i = 0; i < strs?.length; i++) {
    const str = strs[i]
    content += `<tspan x="10" y="${padding * (i + 1)}">${str}</tspan>`
  }
  return `
    <svg 
      width="46" 
      height="${isSmall ? 90 : 130}" 
      viewBox="0 0 46 ${isSmall ? 90 : 130}" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g id="颜色统一" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="画板备份-16" transform="translate(-541.000000, -106.000000)">
              <g id="编组-9" transform="translate(541.000000, 106.000000)">
                  <g id="编组-23" transform="translate(6.000000, 6.000000)">
                      <path 
                        d="${
                          isSmall
                            ? "M33.2972182,0.702781845 L33.2972182,80 L7.45757322,80 L0.702781845,74 L0.702781845,6.55953146 L6.89172402,0.702781845 L33.2972182,0.702781845 Z"
                            : "M33.2972182,0.702781845 L33.2972182,117.297218 L7.45757322,117.297218 L0.702781845,110.224465 L0.702781845,6.55953146 L6.89172402,0.702781845 L33.2972182,0.702781845 Z"
                        }" 
                        id="矩形" 
                        stroke-opacity="0.602245411" 
                        stroke="var(--bookmark-border-color)" 
                        stroke-width="1.40556369" 
                        fill-opacity="0.8" 
                        fill="var(--bookmark-bg-color)" 
                        fill-rule="nonzero"
                      ></path>
                      <text 
                        id="文本" 
                        font-family="SourceHanSansCN-Medium, Source Han Sans CN" 
                        font-size="14" 
                        font-weight="400" 
                        line-spacing="20" 
                        fill="var(--bookmark-color)"
                      >
                        ${content}
                      </text>
                      <g
                        id="编组-24" 
                        transform="${
                          isSmall ? "translate(15.000000, 62)" : "translate(15.000000, 99.000000)"
                        }" 
                        fill="var(--bookmark-color)"
                      >
                        <polygon id="路径-76" points="0 1.8189894e-12 5 4.20276104 0 8.40552207"></polygon>
                      </g>
                  </g>
              </g>
          </g>
      </g>
    </svg>
  `
}

export function svgToDataURL(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
